export default __webpack_public_path__ + "static/media/KTOLOGO.1eba7804.png";